export const sortedDataFn = (arr) => arr?.slice()?.sort((a, b) => a.id - b.id);